import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './theme/layout/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './theme/layout/admin-layout/admin-layout.component';
import { PublicLayoutComponent } from './theme/layout/public-layout/public-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';
import { UnsubscribeComponent } from './modules/auth/unsubscribe/unsubscribe.component';
import { PublicFormComponent } from './modules/workspace/forms-iq/forms/public-form/public-form.component';
import { ApiLayoutComponent } from './theme/layout/api-layout/api-layout.component';
import { AboutUsComponent } from './theme/layout/public-layout/pages/about-us/about-us.component';
import { ContactUsComponent } from './theme/layout/public-layout/pages/contact-us/contact-us.component';
import { OurMissionComponent } from './theme/layout/public-layout/pages/our-mission/our-mission.component';
import { PrivacyPolicyComponent } from './theme/layout/public-layout/pages/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './theme/layout/public-layout/pages/terms-conditions/terms-conditions.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: PublicLayoutComponent,
  },
  {
    path: 'about',
    component: AboutUsComponent,
  },
  {
    path: 'contact',
    component: ContactUsComponent,
  },
  {
    path: 'mission',
    component: OurMissionComponent,
  },
  {
    path: 'docs',
    component: ApiLayoutComponent,
  },
  {
    path: 'forms/:wid/:id',
    component: PublicFormComponent,
  },
  {
    path: 'workspace',
    loadChildren: () =>
      import('./theme/theme.module').then(m => m.ThemeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./modules/workspace/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin-panel/admin-panel.module').then(
        m => m.AdminPanelModule,
      ),
  },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'unsubscribe/:hash', component: UnsubscribeComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms', component: TermsConditionsComponent },
  { path: 'api-auth', loadComponent: () => import('./shared/components/api-auth/api-auth.component').then(m => m.ApiAuthComponent) },
  // {
  //   path: '**',
  //   redirectTo: 'workspace',
  // },
];
